const {parseInt} = globalThis;

export default {
    props: {
        slideHandler: {
            type: Function,
            default: null
        }
    },
    methods: {
        slideTo(direction)
        {
            if (this.slideHandler)
            {
                this.slideHandler(direction);
                return;
            }
            const {currentRoute} = this.$router;
            const {module, slide} = currentRoute.params;
            this.$router.push({
                name: currentRoute.name,
                params: {
                    module,
                    slide: (parseInt(slide || 1, 10) + direction).toString()
                }
            });
        }
    }
};
